import { render, staticRenderFns } from "./account_authorization_page.vue?vue&type=template&id=551ad82e&"
import script from "./account_authorization_page.vue?vue&type=script&lang=js&"
export * from "./account_authorization_page.vue?vue&type=script&lang=js&"
import style0 from "./account_authorization_page.vue?vue&type=style&index=0&id=551ad82e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports